import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const Button = React.memo(({ disabled, onClick }) => (
  <button
    className={styles.sidebarButton}
    disabled={disabled}
    onClick={onClick}
    data-test-id="waiting-room-sidebar-button"
  >
    Notify the Provider
  </button>
));

Button.displayName = 'Button';

Button.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Button;
